import React from "react";
import FoundersImage from "../../../../../../assets/images/about/founders.png";
import SectionHead from "./SectionHead";

const Humans = () => (
  <section className="humans" aria-labelledby="humans-title">
    <div className="wrap">
      <SectionHead
        number="06"
        title="The humans"
        emphasis="behind it."
        id="humans-title"
      />
      <div className="humans-grid">
        <div className="founders-photo">
          <img
            src={FoundersImage}
            alt="Chris Rawlinson and Jake Courage, the 42courses co-founders."
            loading="lazy"
          />
        </div>
        <div className="members-stack">
          <article className="member">
            <div className="member-name">Chris Rawlinson</div>
            <div className="member-role">Founder &amp; CEO</div>
            <ul className="member-facts">
              <li>
                Designed and sold <em>intelligent homes</em> in London, long
                before they were called "smart".
              </li>
              <li>
                Learned to become a <em>commercial pilot</em> in South Africa.
              </li>
              <li>
                Helped start Stormhoek wine, the first brand grown through
                social media advertising.
              </li>
              <li>
                Looked after Innovation at <em>Ogilvy</em> and directed Stream
                for WPP.
              </li>
              <li>Dyslexic. Which is probably why 42courses isn't boring.</li>
              <li>
                Still writes, talks and teaches about culture, tech and
                creativity.
              </li>
            </ul>
          </article>

          <article className="member">
            <div className="member-name">Jake Courage</div>
            <div className="member-role">Co-founder</div>
            <ul className="member-facts">
              <li>
                Has, objectively, <em>the coolest name in the world</em>.
              </li>
              <li>
                Master's in <em>Japanese</em> from the University of Edinburgh,
                of all places.
              </li>
              <li>
                Ran the global advertising accounts of{" "}
                <em>some of the world's leading companies</em>.
              </li>
              <li>
                <em>Fun fact:</em> helped create the legendary Halo launch
                campaigns at McCann. The fictional in-game photographer "Jake
                Courage" was named after him.
              </li>
              <li>
                Plays the steel drums (self-rated standard: enthusiastic) and
                samples obscure rums (also self-rated standard: enthusiastic).
              </li>
              <li>
                Self-describes as a "devout infovore". A word he may have
                invented.
              </li>
            </ul>
          </article>
        </div>
      </div>
    </div>
  </section>
);

export default Humans;
